<template>
  <div class="gs-walkthrough">
    <button type="button" class="gs-walkthrough__preview" aria-label="Play affiliate portal walkthrough"
      aria-haspopup="dialog" @click="isOpen = true">
      <img :src="poster" alt="Affiliate portal walkthrough: links, swipes and stats" />
      <span class="gs-walkthrough__play" aria-hidden="true"><gs-icon name="play" size="32" /></span>
    </button>
    <mounting-portal v-if="isOpen" mount-to="body" append>
      <video-dialog :value="isOpen" title="Affiliate portal walkthrough" size="xl"
        class="gs-app gs-walkthrough-dialog" @input="isOpen = $event">
        <div class="gs-walkthrough-dialog__player">
          <iframe :src="playingSource" title="Affiliate portal walkthrough video"
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen />
        </div>
      </video-dialog>
    </mounting-portal>
  </div>
</template>

<script>
import { MountingPortal } from 'portal-vue';
import createAccessibleModal from '../../../../groove-ui-kit-v2/src/vue2/accessible-modal';
import poster from '@/assets/images/affiliate-portal-walkthrough.png';

export default {
  components: { MountingPortal, VideoDialog: createAccessibleModal() },
  props: { source: { type: String, required: true } },
  data: () => ({ isOpen: false, poster }),
  computed: {
    playingSource() {
      return `${this.source}${this.source.includes('?') ? '&' : '?'}autoplay=1`;
    },
  },
};
</script>

<style scoped>
.gs-walkthrough { min-width: 0; }
.gs-walkthrough__preview {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  background: #080522;
  border: 0;
  border-radius: var(--gs-radius-md, 12px);
  cursor: pointer;
}
.gs-walkthrough__preview img { display: block; width: 100%; height: auto; }
.gs-walkthrough__play {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  color: #fff;
  background: var(--gs-primary, #ff168a);
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, .4);
  transform: translate(-50%, -50%);
  transition: transform 150ms ease;
}
.gs-walkthrough__preview:hover .gs-walkthrough__play { transform: translate(-50%, -50%) scale(1.08); }
.gs-walkthrough__preview:focus-visible { outline: 3px solid var(--gs-primary, #ff168a); outline-offset: 4px; }
.gs-walkthrough-dialog { padding: 16px; }
.gs-walkthrough-dialog >>> .gs-modal__panel { width: min(100%, 1120px); max-height: 100%; }
.gs-walkthrough-dialog >>> .gs-modal__body { padding: 0; }
.gs-walkthrough-dialog__player { position: relative; padding-bottom: 56.25%; height: 0; background: #000; }
.gs-walkthrough-dialog__player iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; }
@media (max-width: 560px) { .gs-walkthrough-dialog { padding: 8px; } }
</style>
